<body>
  <!-- Header -->
  <!-- <header class="kemis-header">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-auto">
          <img src="../../../assets/img/logo1.png" alt="KEMIS - Kenya Education Management Information System"
            class="kemis-logo" />
        </div>
      </div>
    </div>
  </header> -->
  <div class="container-fluid topbg">
    <div class="row align-items-center flex-wrap text-white px-3 px-md-4">
      <!-- Left: Contact Info -->
      <div
        class="col-6 col-md-6 mb-2 mb-md-0 d-flex flex-column flex-sm-row align-items-start align-items-sm-center gap-3">
        <div class="d-md-block d-none d-sm-none"><i class="bi bi-whatsapp"></i> +254 203318581</div>
        <div class="d-md-block d-none d-sm-none"><i class="bi bi-envelope"></i> info@kemis.go.ke</div>
      </div>

      <!-- Right: Search, Login, Social -->
      <div
        class="col-6 col-md-6 d-flex justify-content-start justify-content-md-end align-items-center flex-wrap gap-3">
        <!-- <div class="search-btn d-none d-lg-block">
          <i class="bi bi-search"></i>
        </div> -->

        <button class="login-btn" (click)="GoToLogin()">Login</button>

        <div class="social-icons d-flex justify-content-between gap-2">
          <a href="#"><i class="bi bi-facebook"></i></a>
          <!-- <a href="#"><i class="bi bi-twitter-x"></i></a> -->
          <a href="#"><i class="bi bi-youtube"></i></a>
          <a href="#"><i class="bi bi-linkedin"></i></a>
        </div>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg py-2" style="background-color: #fff !important;">
    <div class="container-fluid px-4 d-flex align-items-center justify-content-between flex-wrap">
      <!-- Left Logo -->
      <a class="navbar-brand d-flex align-items-center order-2 order-lg-0" href="#">
        <img src="../../../assets/images/landing_imgs/Ministry-of-Kenya-Logo.png" alt="Left Logo"
          class="logo-img me-xl-2" />
      </a>

      <!-- Mobile Toggle Button -->
      <!-- <button class="navbar-toggler p-2" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar"
        aria-controls="mainNavbar" aria-expanded="false" aria-label="Toggle navigation">
        <i class="bi bi-list"></i>
      </button> -->

      <!-- Nav Items -->
      <div class="collapse navbar-collapse justify-content-center" id="mainNavbar">
        <!-- <ul class="navbar-nav mx-auto justify-content-center w-100">
          <li class="nav-item">
            <a class="nav-link nav-home" href="#">Home</a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-about" href="#about-kemis">About KEMIS</a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-modules" href="#system-module">System Modules</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-edulocker" href="#">EduLocker</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-stakeholder" href="#">Stakeholder Portals</a>
          </li> -->
        <!-- <li class="nav-item">
            <a class="nav-link nav-resources">Resources</a>
          </li>
          <li class="nav-item">
            <a class="nav-link text-dark" href="#support">Support</a>
          </li>
        </ul> -->
      </div>

      <!-- Right Logo -->
      <div class="d-lg-block d-none order--2">
        <img src="../../../assets/images/landing_imgs/Kemis-Logo.png" alt="Right Logo" class="logo-img" />
      </div>
    </div>
  </nav>
  <!-- Main Content -->
  <main class="kemis-main">
    <div class="container">
      <!-- Progress Indicator -->
      <div class="progress-section">
        <!-- Progress Steps -->
        <div class="progress-steps">
          <div class="step-item" [class.active]="currentStep >= 1">
            <div class="step-number">1</div>
          </div>
          <div class="step-line"></div>
          <div class="step-item" [class.active]="currentStep >= 2">
            <div class="step-number">2</div>
          </div>
          <div class="step-line"></div>
          <div class="step-item" [class.active]="currentStep >= 3">
            <div class="step-number">3</div>
          </div>
        </div>

        <div class="step-description">
          <p class="mb-0" id="step-text">
            Step {{ currentStep }} of 3:
            {{
            currentStep === 1
            ? "Select Institution Type"
            : currentStep === 2
            ? "Institution Details"
            : "Payment"
            }}
          </p>
        </div>
      </div>

      <!-- Step 1: Institution Type Selection -->
      <div class="step-content" *ngIf="currentStep === 1" id="step-1-content">
        <div class="row justify-content-center">
          <div class="col-lg-2">
            <button class="back-arrow mt-5" (click)="goBack()" title="Back to Login" style="text-decoration: none !important; position: absolute; top:7%; left:7%;
              display: block !important;
              margin-bottom: 0.75rem !important;">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
          </div>
          <div class="col-lg-8">
            <div class="kemis-card">
              <div class="card-header text-center">
                <h2 class="card-title">Institution Onboarding</h2>
                <p class="card-description">
                  Select your institution type to begin the Onboarding process
                </p>
              </div>
              <div class="card-body">
                <div class="institution-types">
                  <div class="institution-option" (click)="selectInstitutionType('basic')"
                    [class.selected]="selectedType === 'basic'">
                    <div class="option-icon">
                      <i class="fas fa-graduation-cap"></i>
                      <!-- Basic Education -->
                    </div>
                    <div class="option-content">
                      <h3>Basic Education</h3>
                      <p>Primary and Secondary Schools</p>
                    </div>
                    <div class="option-radio">
                      <div class="radio-indicator" (click)="institution_level=1"></div>
                    </div>
                  </div>

                  <div class="institution-option" (click)="selectInstitutionType('tvet')"
                    [class.selected]="selectedType === 'tvet'">
                    <div class="option-icon">
                      <i class="fas fa-tools"></i>
                      <!-- TVET -->
                    </div>
                    <div class="option-content">
                      <h3>TVET</h3>
                      <p>Technical and Vocational Education</p>
                    </div>
                    <div class="option-radio">
                      <div class="radio-indicator" (click)="institution_level=2"></div>
                    </div>
                  </div>

                  <div class="institution-option" (click)="selectInstitutionType('higher')"
                    [class.selected]="selectedType === 'higher'">
                    <div class="option-icon">
                      <i class="fas fa-university"></i>
                      <!-- Higher Education -->
                    </div>
                    <div class="option-content">
                      <h3>Higher Education</h3>
                      <p>Universities and Colleges</p>
                    </div>
                    <div class="option-radio">
                      <div class="radio-indicator" (click)="institution_level=3"></div>
                    </div>
                  </div>
                </div>

                <!-- Continue Button -->
                <div class="text-center mt-4">
                  <button class="btn kemis-btn-primary" id="continue-btn" [disabled]="!selectedType"
                    (click)="nextStep()">Proceed to Institution Onboarding
                    <i class="fas fa-chevron-right ms-2"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Step 2: Institution Details -->

      <div class="step-content" *ngIf="currentStep === 2" id="step-2-content">
        <div class="content-wrapper">
          <div class="kemis-card">
            <div class="card-header">
              <h2 class="card-title">Institution Details</h2>
              <p class="card-description">
                Provide your institution information to complete Onboarding
              </p>
            </div>
            <div class="card-body">
              <div id="institution-form" [formGroup]="instituteRegForm">
                <!-- Basic Institution Details -->
                <div *ngIf="selectedType == 'basic'">
                  <div class="registration-options">
                    <label class="custom-radio">
                      <input type="radio" name="registrationType" value="new"
                        (change)="onRegistrationTypeChange('new'); ClearData()"
                        [checked]="registrationType === 'new'" />
                      <span class="radio-label">New Onboarding</span>
                    </label>
                    <!-- <label class="custom-radio">
                      <input type="radio" name="registrationType" value="re"
                        (change)="onRegistrationTypeChange('re'); ClearData()" />
                      <span class="radio-label">Re-Registration</span>
                    </label> -->
                  </div>

                  <div class="form-section">
                    <h4 class="section-title">
                      <i class="fas fa-building section-icon"></i>
                      Institution Details
                    </h4>

                    <div class="form-grid">
                      <div class="form-group" *ngIf="registrationType == 're'">
                        <label for="contactEmail" class="form-label">Registration Number *</label>

                        <input type="text" class="form-control kemis-input" [(ngModel)]="registrationNumber"
                          [ngModelOptions]="{ standalone: true }" (change)="getDetailsByRegistrationNumber()" />
                      </div>
                      <div class="form-group" *ngIf="registrationType == 're'">
                        <label for="contactEmail" class="form-label">Reason For Reregistration *</label>
                        <select class="form-control kemis-input" formControlName="reregistration_reasons">
                          <option value="" selected disabled hidden>Select Reason</option>
                          <option value="1">
                            Need to increase school enrolment capacity
                          </option>
                          <option value="2">Need to change school name</option>
                          <option value="3">Expiry of licenses e.t.c.</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="contactEmail" class="form-label">Institution Type
                          <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" formControlName="institution_type">
                          <option value="" disabled selected hidden>Select</option>
                          <option value="1">Boy's School</option>
                          <option value="2">Girl's School</option>
                          <option value="3">Mixed School</option>
                        </select>
                        <div class="text-danger" *ngIf="(submitted) && fc.institution_type.invalid">
                          <small *ngIf="fc.institution_type.errors?.['required']">Please select institution
                            type.</small>
                        </div>
                        <!-- <div class="invalid-feedback">
                          Please select an institution type.
                        </div> -->
                      </div>
                      <div class="form-group">
                        <label for="contactEmail" class="form-label">
                          <!-- {{ registrationType == "re" ? 'Email Address' : 'Email ID' }} -->
                          Institution Email
                          <sup class="text-danger">*</sup>
                        </label>
                        <input type="email" class="form-control kemis-input" id="contactEmail" name="contactEmail"
                          placeholder="Enter email address" formControlName="email" (blur)="validateEmail($event)"
                          (keydown)="validateEmailKeydown($event)" (change)="checkEmail($event)"
                          (keypress)="keyPressValdsn($event, 'AS')" />
                        <!-- <div class="text-danger" *ngIf="(fc.email.touched || submitted) && fc.email.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.email.invalid">
                          <small *ngIf="fc.email.errors?.['required']">Email ID is required.</small>
                          <small *ngIf="fc.email.errors?.['pattern']">Please enter valid email id.</small>
                        </div>
                        <!-- <div class="invalid-feedback">
                          Please provide a valid email address.
                        </div> -->
                      </div>
                      <!-- <div class="form-group">
                        <label for="contactPhone" class="form-label">
                          Institution Telephone Number/Landline
                          <sup class="text-danger">*</sup></label>
                          <div class="d-flex gap-2">
                            <select class="form-select small-width" [(ngModel)]="countryCode"
                              formControlName = "mobilenocode_countryid">
                              <option *ngFor="let item of country" [value]="item.COUNTRY_ID">{{
                                item.COUNTRY_CONNECTING_CODE }}</option>
                            </select>
                            <input type="tel" class="form-control kemis-input" id="contactPhone" name="contactPhone"
                              [placeholder]="registrationType === 're' ? 'Telephone Number' : 'Telephone Number/Landline'"
                              formControlName="mobileno" inputmode="numeric" maxlength="15" (input)="onMobileInput($event)" />
                        <div class="text-danger" *ngIf="fc.mobileno.touched && fc.mobileno.errors">
                          <small *ngIf="fc.mobileno.errors?.['required']">{{
                            registrationType === "re"
                            ? "Telephone Number"
                            : "Telephone Number/Landline"
                            }}
                            is required.</small>
                          <small *ngIf="fc.mobileno.errors?.['pattern']">
                            {{
                            registrationType === "re"
                            ? "Telephone Number"
                            : "Mobile Number"
                            }}
                            must be 10 - 12 digits.
                          </small>

                          <small *ngIf="fc.mobileno.errors?.['minlength']">Please enter 10 digits minimum.</small>
                        </div>
                          </div>
                      </div> -->
                      <div class="form-group">
                        <label for="contactPhone" class="form-label">
                          Institution Telephone Number/Landline
                          <sup class="text-danger">*</sup></label>
                        <div class="d-flex gap-2">
                          <select class="form-select small-width dropdown-sm" [(ngModel)]="countryCode"
                            formControlName="mobilenocode_countryid">
                            <option *ngFor="let item of country" [value]="item.COUNTRY_ID">{{
                              item.COUNTRY_CONNECTING_CODE }}</option>
                          </select>
                          <input type="tel" class="form-control kemis-input" id="contactPhone" name="contactPhone"
                            [placeholder]="registrationType === 're' ? 'Telephone Number' : 'Telephone Number/Landline'"
                            formControlName="mobileno" inputmode="numeric" maxlength="15"
                            (input)="onMobileInput($event)" />
                        </div>
                        <!-- <div class="text-danger" *ngIf="(fc.mobileno.touched || submitted) && fc.mobileno.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.mobileno.invalid">
                          <small *ngIf="fc.mobileno.errors?.['required']">{{
                            registrationType === "re"
                            ? "Telephone Number"
                            : "Telephone Number/Landline"
                            }}
                            is required.</small>
                          <small *ngIf="fc.mobileno.errors?.['pattern']">{{
                            registrationType === "re"
                            ? "Telephone Number"
                            : "Mobile Number"
                            }}
                            must be 9 - 12 digits.</small>
                          <small *ngIf="fc.mobileno.errors?.['minlength']">Please enter 9 digits minimum.</small>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionName" class="form-label">Institution Name
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="institutionName" name="institutionName"
                          placeholder="Enter institution name" formControlName="TNT_NAME"
                          (keypress)="keyPressValdsn($event, 'AN')" />
                        <!-- (keypress)="keyPressValdsn($event, 'AN')" (change)="checkInstitutionName($event)" /> -->
                        <!-- <div class="invalid-feedback">
                          Please provide institution name.
                        </div> -->
                        <!-- <div class="text-danger" *ngIf="(fc.TNT_NAME.touched || submitted) && fc.TNT_NAME.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_NAME.invalid">
                          <small *ngIf="fc.TNT_NAME.errors?.['required']">Please Provide Institution Name.</small>
                        </div>
                      </div>
                      <!-- Add this after the Institution Name field (around line 1100 in the HTML) -->
                      <div class="form-group">
                        <label for="headOfInstitution" class="form-label">Head of Institution <sup
                            class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="headOfInstitution"
                          name="headOfInstitution" placeholder="Enter head of institution name"
                          formControlName="tnt_admin_name" (keypress)="keyPressValdsn($event, 'AN')" />
                        <div class="text-danger" *ngIf="(submitted) && fc.tnt_admin_name.invalid">
                          <small *ngIf="fc.tnt_admin_name.errors?.['required']">Please Provide Head of Institution
                            Name.</small>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionAddress" class="form-label">Postal Code <sup
                            class="text-danger">*</sup></label>
                        <!-- pattern="[0-9]*" -->
                        <input type="text" formControlName="TNT_DESCRIPTION" class="form-control kemis-input"
                          placeholder="e.g. 00100" (keypress)="keyPressValdsn($event, 'AN')" />
                        <!-- (input)="onPostalCodeInput($event)" -->
                        <!-- <div class="text-danger" *ngIf="(fc.TNT_DESCRIPTION.touched || submitted) && fc.TNT_DESCRIPTION.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_DESCRIPTION.invalid">
                          <small *ngIf="fc.TNT_DESCRIPTION.errors?.['required']">Please Provide The Postal Code.</small>
                          <!-- <small *ngIf="fc.TNT_DESCRIPTION.errors?.['pattern']">Postal Code must not start with zero.</small> -->
                        </div>
                        <!-- <div class="invalid-feedback">
                          Please provide the institution address.
                        </div> -->
                      </div>
                      <!-- <div class="form-group" *ngIf="registrationType != 're'">
                        <label for="nearestLandmark" class="form-label"
                          >Nearest landmark/town</label
                        >
                        <input
                          type="text"
                          class="form-control kemis-input"
                          id="nearestLandmark"
                          name="nearestLandmark"
                          placeholder="Enter nearest landmark"
                          formControlName="landmark"
                        />
                      </div> -->
                      <div class="form-group">
                        <label for="county" class="form-label">County <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="county" name="county"
                          formControlName="TNT_CONCURRENT_AVSESSIONS" (change)="subCounties($any($event.target).value)">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of County" [value]="item.COUNTIES_ID">
                            {{ item.COUNTIES_NAME }}
                          </option>
                        </select>
                        <!-- <div class="text-danger" *ngIf="(fc.TNT_CONCURRENT_AVSESSIONS.touched || submitted) && fc.TNT_CONCURRENT_AVSESSIONS.invalid-feedback"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_CONCURRENT_AVSESSIONS.invalid-feedback">
                          <small *ngIf="fc.TNT_CONCURRENT_AVSESSIONS.errors?.['required']">Please Select County.</small>
                        </div>
                        <!-- <div class="invalid-feedback">
                          Please select a county.
                        </div> -->
                      </div>
                      <div class="form-group">
                        <label for="subCounty" class="form-label">Sub County <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="subCounty" name="subCounty"
                          formControlName="TNT_USERSPERSESSION" (change)="ChangeSC()">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of subCounty" [value]="item.sub_counties_id">
                            {{ item.sub_counties_name }}
                          </option>
                        </select>
                        <!-- <div class="text-danger" *ngIf="(fc.TNT_USERSPERSESSION.touched || submitted) && fc.TNT_USERSPERSESSION.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.TNT_USERSPERSESSION.invalid">
                          <small *ngIf="fc.TNT_USERSPERSESSION.errors?.['required']">Please Select Sub-County.</small>
                        </div>
                        <!-- <div class="invalid-feedback">
                          Please select a sub-county.
                        </div> -->
                      </div>
                      <div class="form-group">
                        <label for="constituency" class="form-label">Constituency</label>
                        <select class="form-control kemis-input" id="constituency" name="constituency"
                          formControlName="constituency">
                          <option value="0">Select</option>
                          <option *ngFor="let item of Constituency" [value]="item.con_counties_id">
                            {{ item.con_counties_name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group" *ngIf="registrationType == 're'">
                        <label for="registrationNumber" class="form-label">Institution Reg No</label>
                        <input type="text" class="form-control kemis-input" id="registrationNumber"
                          name="registrationNumber" placeholder="Enter registration number"
                          formControlName="school_regno" />
                        <div class="invalid-feedback">
                          Please provide Institution Reg No.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionLocation" class="form-label">Institution Postal Address
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="institutionLocation"
                          name="institutionLocation" (keypress)="keyPressValdsn($event, 'AS')"
                          placeholder="P.O Box  12345-00123, Nairobi, Kenya" formControlName="schoollocation" />
                        <!-- <div class="text-danger" *ngIf="(fc.schoollocation.touched || submitted) && fc.schoollocation.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.schoollocation.invalid">
                          <small *ngIf="fc.schoollocation.errors?.['required']">Please Provide The Institution Postal
                            Location.</small>
                          <!-- <small *ngIf="fc.schoollocation.errors?.['pattern']">Institution Postal Location must not
                            start with
                            zero and be 2 - 15 digits.</small> -->
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionLevel" class="form-label">Institution Level
                          <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="institutionLevel" name="institutionLevel"
                          formControlName="schoollevel">
                          <!-- <option value="">Select</option> -->
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of levels" [value]="item.level_id">
                            {{ item.level_desc }}
                          </option>
                        </select>
                        <!-- <div class="text-danger" *ngIf="(fc.schoollevel.touched || submitted) && fc.schoollevel.invalid"> -->
                        <div class="text-danger" *ngIf="(submitted) && fc.schoollevel.invalid">
                          <small *ngIf="fc.schoollevel.errors?.['required']">Please Select Institution Level.</small>
                        </div>
                      </div>
                      <div class="form-group" *ngIf="registrationType == 're'">
                        <label for="institutionNameCertificate" class="form-label">Institution Name in
                          Certificate</label>
                        <input type="text" class="form-control kemis-input" id="institutionNameCertificate"
                          name="institutionNameCertificate" placeholder="Enter name as it appears on certificate"
                          formControlName="schoolnameincertificate" />
                      </div>
                      <!-- Radio Button Section -->
                      <div class="form-group">
                        <label class="form-label">Have a Valid Registration Certificate? <sup
                            class="text-danger">*</sup></label>
                        <div class="d-flex gap-4">
                          <label class="custom-radio">
                            <input type="radio" name="validCertificate" value="yes"
                              (change)="onCertificateChange('yes')" [checked]="is_valid_certificate === true" />
                            <span class="radio-label">Yes</span>
                          </label>
                          <label class="custom-radio">
                            <input type="radio" name="validCertificate" value="no" (change)="onCertificateChange('no')"
                              [checked]="is_valid_certificate === false" />
                            <span class="radio-label">No</span>
                          </label>
                        </div>
                      </div>

                      <!-- Warning message when "No" is selected -->
                      <div class="alert alert-warning mt-2 mb-3" role="alert" *ngIf="is_valid_certificate === false">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        Your approval process will take longer due to absence of the registration certificate.
                      </div>

                      <!-- Institution Onboarding Certificate Number - Show only when Yes is selected -->
                      <div class="form-group" *ngIf="is_valid_certificate === true">
                        <label for="registrationNumber" class="form-label">Institution Certificate Number
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="registrationNumber"
                          name="registrationNumber" placeholder="Enter registration number"
                          formControlName="registration_no" (blur)="checkRegNo($event.target.value)" />
                        <div class="invalid-feedback" *ngIf="submitted && fc.registration_no.invalid">
                          Please Provide Institution Certificate Number.
                        </div>
                      </div>

                      <!-- Institution Onboarding Certificate - Show only when Yes is selected -->
                      <div class="form-group" *ngIf="is_valid_certificate === true">
                        <label for="InstitutionRegCertificate" class="form-label">Institution Certificate
                          <sup class="text-danger">*</sup></label>
                        <input type="file" (change)="changeFileForMuiltiple($event,1)" class="form-control"
                          #fileInputRef1 />
                        <small class="text-muted">File must be in PDF format only and file size less than 8MB. </small>
                        <div class="mt-1" *ngIf="InstitutionRegCertificate">
                          <a [href]="getFileUrl(InstitutionRegCertificate)" target="_blank"
                            class="text-primary text-decoration-underline">
                            View Certificate
                          </a>
                        </div>
                        <div class="invalid-feedback" *ngIf="submitted && fc.tnt_registration_certificate.invalid">
                          Please provide Institution Certificate.
                        </div>
                      </div>
                      <!-- <div class="form-group">
                        <label for="registrationNumber" class="form-label">Institution Certificate Number
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="registrationNumber"
                          name="registrationNumber" placeholder="Enter registration number"
                          formControlName="registration_no" (blur)="checkRegNo($event.target.value)" />
                        <div class="invalid-feedback">
                          Please Provide Institution Certificate Number.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="InstitutionRegCertificate" class="form-label">Institution Certificate
                          <sup class="text-danger">*</sup></label>
                        <input type="file" (change)="changeFileForMuiltiple($event,1)" class="form-control"
                          #fileInputRef1 />
                        <small class="text-muted"> Only PDF files are allowed </small>
                        <div class="mt-1" *ngIf="InstitutionRegCertificate">
                          <a [href]="getFileUrl(InstitutionRegCertificate)" target="_blank"
                            class="text-primary text-decoration-underline">
                            View Certificate
                          </a>
                        </div>
                        <div class="invalid-feedback">
                          Please provide Institution Certificate.
                        </div>
                      </div> -->
                      <!-- Boys Capacity -->
                      <div class="form-group"
                        *ngIf="fc.institution_type.value == '1' || fc.institution_type.value == '3'">

                        <label for="tnt_boys_capacity" class="form-label">
                          Number of Boys Learners
                          <sup class="text-danger">*</sup>
                        </label>

                        <input type="text" class="form-control kemis-input" id="institutionBoysCapacity"
                          name="tnt_boys_capacity" placeholder="Enter boys capacity" formControlName="tnt_boys_capacity"
                          appNumericOnly (keypress)="onlyNumbers($event)" (input)="validateMaxCapacity($event, 'boys')"
                          (blur)="formatNumberOnBlur('boys')" />

                        <div class="text-danger" *ngIf="submitted && fc.tnt_boys_capacity.errors?.['required']">
                          <small> Number of Boys Learners is required.</small>
                        </div>
                      </div>

                      <!-- Girls Capacity -->
                      <div class="form-group"
                        *ngIf="fc.institution_type.value == '2' || fc.institution_type.value == '3'">

                        <label for="tnt_girls_capacity" class="form-label">
                          Number of Girls Learners
                          <sup class="text-danger">*</sup>
                        </label>

                        <input type="text" class="form-control kemis-input" id="institutionGirlsCapacity"
                          name="tnt_girls_capacity" placeholder="Enter girls capacity"
                          formControlName="tnt_girls_capacity" appNumericOnly (keypress)="onlyNumbers($event)"
                          (input)="validateMaxCapacity($event, 'girls')" (blur)="formatNumberOnBlur('girls')" />

                        <div class="text-danger" *ngIf="submitted && fc.tnt_girls_capacity.errors?.['required']">
                          <small> Number of Girls Learners is required.</small>
                        </div>
                      </div>
                      <!-- SNE Boys Capacity -->
                      <div class="form-group"
                        *ngIf="fc.institution_type.value == '1' || fc.institution_type.value == '3'">

                        <label for="tnt_sne_boyscapacity" class="form-label">
                          Number of SNE Boys <sup class="text-danger">*</sup>
                        </label>

                        <input type="text" class="form-control kemis-input" id="institutionBoysCapacity"
                          name="tnt_sne_boyscapacity" placeholder="Enter boys capacity"
                          formControlName="tnt_sne_boyscapacity" appNumericOnly (keypress)="onlyNumbers($event)"
                          (input)="validateMaxCapacity($event, 'boys')" (blur)="formatNumberOnBlur('boys')" />

                        <div class="text-danger" *ngIf="submitted && fc.tnt_sne_boyscapacity.errors?.['required']">
                          <small> Number of SNE Boys is required. </small>
                        </div>
                      </div>

                      <!-- SNE Girls Capacity -->
                      <div class="form-group"
                        *ngIf="fc.institution_type.value == '2' || fc.institution_type.value == '3'">

                        <label for="tnt_sne_girlscapacity" class="form-label">
                          Number of SNE Girls Learners
                          <sup class="text-danger">*</sup>
                        </label>

                        <input type="text" class="form-control kemis-input" id="institutionGirlsCapacity"
                          name="tnt_sne_girlscapacity" placeholder="Enter girls capacity"
                          formControlName="tnt_sne_girlscapacity" appNumericOnly (keypress)="onlyNumbers($event)"
                          (input)="validateMaxCapacity($event, 'girls')" (blur)="formatNumberOnBlur('girls')" />

                        <div class="text-danger" *ngIf="submitted && fc.tnt_sne_girlscapacity.errors?.['required']">
                          <small> Number of SNE Girls is required.</small>
                        </div>
                      </div>
                      <!-- SNE Capacity -->
                      <div class="form-group">
                        <label for="tnt_sne_capacity" class="form-label">
                          Total Number of Learners <sup class="text-danger">*</sup>
                        </label>
                        <input type="text" class="form-control kemis-input" id="institutionSneCapacity"
                          name="tnt_sne_capacity" placeholder="Enter SNE capacity" formControlName="tnt_sne_capacity"
                          appNumericOnly (keypress)="onlyNumbers($event)" (input)="validateMaxCapacity($event, 'sne')"
                          (blur)="formatNumberOnBlur('sne')" />


                      </div>

                    </div>
                  </div>
                  <!-- Coordinates Section -->
                  <div class="form-section">
                    <h4 class="section-title">
                      <i class="fas fa-map-marker-alt section-icon"></i>
                      Co-ordinates
                    </h4>
                    <p class="text-danger mb-3" style="font-size: 11px !important">
                      Ensure the co-ordinates are captured while at the
                      flag-post position of the institution or search for your
                      school location through the map for the co-ordinates to be
                      populated
                    </p>

                    <div class="form-group">
                      <label for="latitude" class="form-label">Latitude <sup class="text-danger">*</sup></label>
                      <input type="number" class="form-control kemis-input" id="latitude" name="latitude"
                        placeholder="Enter latitude" step="any" formControlName="latitude" />
                    </div>
                    <div class="form-group">
                      <label for="longitude" class="form-label">Longitude <sup class="text-danger">*</sup></label>
                      <input type="number" class="form-control kemis-input" id="longitude" name="longitude"
                        placeholder="Enter longitude" step="any" formControlName="longitude" />
                    </div>

                    <!-- Centered Button -->
                    <div class="text-center">
                      <button type="button" class="btn kemis-btn-primary mt-2" (click)="getCurrentLocation()">
                        📍 Use Current Location
                      </button>
                    </div>
                    <div class="pt-4">
                      <google-map height="300px" width="100%" [center]="center" [zoom]="zoom"
                        (mapClick)="onMapClick($event)">
                        <map-marker *ngIf="markerPosition" [position]="markerPosition" [title]="'Current Location'"
                          [options]="markerOptions"></map-marker>
                      </google-map>
                    </div>
                  </div>

                  <!-- Basic Education Specific Sections -->
                  <div id="basic-education-sections" class="institution-specific-section">
                    <!-- Teaching Staff Section -->
                    <div class="form-section d-none">
                      <h4 class="section-title">
                        <i class="fas fa-chalkboard-teacher section-icon"></i>
                        Teaching Staff
                      </h4>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="teachingMale" class="form-label">Teaching Male</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="teachingMale"
                            name="teachingMale" placeholder="0" min="0" data-group="teaching"
                            formControlName="noofteaching_male" />
                        </div>
                        <div class="form-group">
                          <label for="teachingFemale" class="form-label">Teaching Female</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="teachingFemale"
                            name="teachingFemale" placeholder="0" min="0" data-group="teaching"
                            formControlName="noofteaching_female" />
                        </div>
                        <div class="form-group full-width">
                          <div class="total-field">
                            <label class="total-label">Total Teaching Staff</label>
                            <input type="number" class="form-control total-input" id="teachingTotal"
                              formControlName="noofteaching_total" readonly />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Non-Teaching Staff Section -->
                    <div class="form-section d-none">
                      <h4 class="section-title">
                        <i class="fas fa-users section-icon"></i>
                        Non-Teaching Staff
                      </h4>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="nonTeachingMale" class="form-label">Non-Teaching Male</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="nonTeachingMale"
                            name="nonTeachingMale" placeholder="0" min="0" data-group="nonteaching"
                            formControlName="noofnonteaching_male" />
                        </div>
                        <div class="form-group">
                          <label for="nonTeachingFemale" class="form-label">Non-Teaching Female</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="nonTeachingFemale"
                            name="nonTeachingFemale" placeholder="0" min="0" data-group="nonteaching"
                            formControlName="noofnonteaching_female" />
                        </div>
                        <div class="form-group full-width">
                          <div class="total-field">
                            <label class="total-label">Total Non-Teaching Staff</label>
                            <input type="number" class="form-control total-input" id="nonTeachingTotal" readonly
                              formControlName="noofnonteaching_total" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Learner Enrollment Section -->
                    <div class="form-section d-none">
                      <h4 class="section-title">
                        <i class="fas fa-user-graduate section-icon"></i>
                        Learner Enrollment
                      </h4>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="enrollmentBoys" class="form-label">Enrollment Boys</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="enrollmentBoys"
                            name="enrollmentBoys" placeholder="0" min="0" data-group="enrollment"
                            formControlName="enrollment_boys" />
                        </div>
                        <div class="form-group">
                          <label for="enrollmentGirls" class="form-label">Enrollment Girls</label>
                          <input type="number" class="form-control kemis-input auto-calculate" id="enrollmentGirls"
                            name="enrollmentGirls" placeholder="0" min="0" data-group="enrollment"
                            formControlName="enrollment_girls" />
                        </div>
                        <div class="form-group full-width">
                          <div class="total-field">
                            <label class="total-label">Total Enrollment</label>
                            <input type="number" class="form-control total-input" id="enrollmentTotal" readonly
                              formControlName="learnerenrolment_total" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Other Details Section -->
                    <div class="form-section" *ngIf="registrationType != 're'">
                      <h4 class="section-title">
                        <i class="fas fa-info-circle section-icon"></i>
                        Other Details
                      </h4>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="sneType" class="form-label">Application Type<sup
                              class="text-danger">*</sup></label>
                          <select class="form-control kemis-input" id="sneType" name="sneType" [(ngModel)]="sneType"
                            formControlName="school_categories" (change)="getSneCategoryList()">
                            <!-- <option value="0">Select</option> -->
                            <option value="" disabled selected hidden>Select</option>
                            <option *ngFor="let item of categories" [value]="item.SCHOOL_CATEGORY_ID">
                              {{ item.SCHOOL_CATEGORY_NAME }}
                            </option>
                          </select>
                          <!-- <div class="text-danger" *ngIf="(fc.school_categories.touched || submitted) && fc.school_categories.invalid"> -->
                          <div class="text-danger" *ngIf="(submitted) && fc.school_categories.invalid">
                            <small *ngIf="fc.school_categories.errors?.['required']">Please Select School Categories
                              Type.</small>
                          </div>
                        </div>
                        <div class="form-group" *ngIf="['2', '3', '4'].includes(sneType)">
                          <label for="sneDetails" class="form-label">Integrated
                            <sup class="text-danger" *ngIf="['2', '3', '4'].includes(sneType)">*</sup></label>
                          <ng-multiselect-dropdown [placeholder]="'Select Categories'" [data]="sneCategoriesList"
                            [(ngModel)]="selectedSneDetails" (ngModelChange)="onSneDetailChange()"
                            [settings]="dropdownSettings" [ngModelOptions]="{ standalone: true }"
                            class="form-control kemis-input">
                          </ng-multiselect-dropdown>
                          <!-- <select
                            class="form-control kemis-input"
                            id="sneDetails"
                            name="sneDetails"
                            [(ngModel)]="sneDetail"
                            [ngModelOptions]="{ standalone: true }"
                          >
                            <option value="0">Select</option>
                            <option value="1">Visual Impairment (VI)</option>
                            <option value="2">
                              Physically Handicapped (PH)
                            </option>
                            <option value="3">Hearing Impairment (HI)</option>
                            <option value="4">Deaf-blindness</option>
                            <option value="5">
                              Intellectual and developmental disabilities
                            </option>
                            <option value="6">
                              Specific learning disabilities
                            </option>
                            <option value="7">Celebral Pulsy</option>
                            <option value="8">
                              Speech and Language Difficulties
                            </option>
                            <option value="9">Multiple Disabilities</option>
                            <option value="10">Autism</option>
                            <option value="11">Albinism</option>
                          </select> -->
                        </div>
                        <div class="form-group" *ngIf="showSubSneDropdown">
                          <label for="sneDetails" class="form-label">Sub Category</label>
                          <ng-multiselect-dropdown [placeholder]="'Select Sub-Categories'" [data]="subSneCategoriesList"
                            [(ngModel)]="selectedSubSneDetails" [settings]="subDropdownSettings"
                            [ngModelOptions]="{ standalone: true }" class="form-control kemis-input">
                          </ng-multiselect-dropdown>
                        </div>
                        <div class="form-group">
                          <label for="accommodationType" class="form-label">Accommodation Type</label>
                          <select class="form-control kemis-input" id="accommodationType" name="accommodationType"
                            formControlName="accommodation_type" placeholder="Select">
                            <option [ngValue]="null" disabled selected hidden>Select</option>
                            <option value="1">Day</option>
                            <option value="2">Boarding</option>
                            <option value="3">Hybrid</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <label for="applicationType" class="form-label">School Categories
                            <sup class="text-danger">*</sup></label>
                          <select class="form-control kemis-input" id="applicationType" name="applicationType"
                            formControlName="applicationtype">
                            <option [ngValue]="null" disabled selected hidden>Select</option>
                            <option *ngFor="let item of ApplicationType" [value]="item.applicationtype_id">
                              {{ item.applicationtype_name }}
                            </option>
                          </select>
                          <!-- <div class="text-danger" *ngIf="(fc.applicationtype.touched || submitted) && fc.applicationtype.invalid"> -->
                          <div class="text-danger" *ngIf="(submitted) && fc.applicationtype.invalid">
                            <small *ngIf="fc.applicationtype.errors?.['required']">Please select Application
                              Type.</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="form-section" *ngIf="registrationType != 're'">
                      <h4 class="section-title">
                        <!-- <i class="fas fa-info-circle section-icon"></i> -->
                        Terms & Condtions
                      </h4>
                      <div class="form-grid">
                        <!-- Data Protection Consent Card -->
                        <div class="form-section data-protection-card" *ngIf="registrationType != 're'">
                          <div class="consent-card">
                            <div class="consent-checkbox-wrapper">
                              <label class="consent-checkbox-label">
                                <input type="checkbox" [(ngModel)]="isDataProtectionChecked"
                                  [ngModelOptions]="{ standalone: true }" (change)="onDataProtectionCheckboxChange()" />
                                <span class="checkbox-custom"></span>
                                <span class="consent-text">
                                  All data and information submitted to the Kenya Education Management Information
                                  System (KEMIS) is protected by the Data Protection Act, 2019 and other relevant
                                  regulations. Users are personally responsible for the accuracy and authenticity of
                                  information entered. Submission of erroneous or falsified data is an offence and may
                                  lead to sanctions or prosecution. By proceeding, you confirm that all submitted data
                                  is accurate and compliant with the Data Protection Act.
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>




                      </div>
                    </div>
                  </div>

                  <!-- TVET and Higher Education Bank Information Section -->
                  <div id="bank-information-section" class="institution-specific-section d-none">
                    <div class="form-section bank-section">
                      <h4 class="section-title">
                        <i class="fas fa-university section-icon"></i>
                        Bank Information
                      </h4>
                      <div class="form-grid">
                        <div class="form-group">
                          <label for="simbaAcc" class="form-label">SIMBA ACC</label>
                          <input type="text" class="form-control kemis-input" id="simbaAcc" name="simbaAcc"
                            placeholder="Enter SIMBA account number" />
                        </div>
                        <div class="form-group">
                          <label for="gpaAccNo" class="form-label">GPA ACC No</label>
                          <input type="text" class="form-control kemis-input" id="gpaAccNo" name="gpaAccNo"
                            placeholder="Enter GPA account number" />
                        </div>
                        <div class="form-group">
                          <label for="bankBranch" class="form-label">Bank Branch</label>
                          <input type="text" class="form-control kemis-input" id="bankBranch" name="bankBranch"
                            placeholder="Enter bank branch" />
                        </div>
                        <div class="form-group">
                          <label for="bankName" class="form-label">Bank Name</label>
                          <input type="text" class="form-control kemis-input" id="bankName" name="bankName"
                            placeholder="Enter bank name" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="selectedType == 'higher' || selectedType == 'tvet'">
                  <div class="form-section">
                    <h4 class="section-title">
                      <i class="fas fa-building section-icon"></i>
                      Institution Details
                    </h4>
                    <div class="form-grid">
                      <div class="form-group">
                        <label for="institutionName" class="form-label">Institution Name
                          <sup class="text-danger">*</sup></label>
                        <input type="text" class="form-control kemis-input" id="institutionName" name="institutionName"
                          placeholder="Enter institution name" formControlName="TNT_NAME" />
                        <div class="invalid-feedback">
                          Please provide institution name.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionAddress" class="form-label">Address <sup
                            class="text-danger">*</sup></label>
                        <textarea class="form-control kemis-input" id="institutionAddress" name="institutionAddress"
                          placeholder="Enter institution address" rows="3" formControlName="TNT_DESCRIPTION"></textarea>
                        <div class="invalid-feedback">
                          Please provide the institution address.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="nearestLandmark" class="form-label">Nearest landmark/town</label>
                        <input type="text" class="form-control kemis-input" id="nearestLandmark" name="nearestLandmark"
                          placeholder="Enter nearest landmark" formControlName="landmark" />
                      </div>
                      <div class="form-group">
                        <label for="county" class="form-label">County <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="county" name="county"
                          formControlName="TNT_CONCURRENT_AVSESSIONS" (change)="subCounties($any($event.target).value)">
                          <option value="">Select County</option>
                          <option *ngFor="let item of County" [value]="item.COUNTIES_ID">
                            {{ item.COUNTIES_NAME }}
                          </option>
                        </select>
                        <div class="invalid-feedback">
                          Please select a county.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="subCounty" class="form-label">Sub County <sup class="text-danger">*</sup></label>
                        <select class="form-control kemis-input" id="subCounty" name="subCounty"
                          formControlName="TNT_USERSPERSESSION">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of subCounty" [value]="item.sub_counties_id">
                            {{ item.sub_counties_name }}
                          </option>
                        </select>
                        <div class="invalid-feedback">
                          Please select a sub-county.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="constituency" class="form-label">Constituency</label>
                        <select class="form-control kemis-input" id="constituency" name="constituency"
                          formControlName="constituency">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of Constituency" [value]="item.con_counties_id">
                            {{ item.con_counties_name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group" *ngIf="registrationType != 're'">
                        <label for="registrationNumber" class="form-label">Institution Reg No</label>
                        <input type="text" class="form-control kemis-input" id="registrationNumber"
                          name="registrationNumber" placeholder="Enter registration number"
                          formControlName="school_regno" />
                        <div class="invalid-feedback">
                          Please provide registration number.
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="institutionLocation" class="form-label">Institution Location</label>
                        <input type="text" class="form-control kemis-input" id="institutionLocation"
                          name="institutionLocation" placeholder="Enter location details"
                          formControlName="schoollocation" />
                      </div>
                      <div class="form-group">
                        <label for="institutionLevel" class="form-label">Institution Level</label>
                        <select class="form-control kemis-input" id="institutionLevel" name="institutionLevel"
                          formControlName="schoollevel">
                          <option value="" disabled selected hidden>Select</option>
                          <option *ngFor="let item of levels" [value]="item.level_id">
                            {{ item.level_desc }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label for="institutionNameCertificate" class="form-label">Institution Name in
                          Certificate</label>
                        <input type="text" class="form-control kemis-input" id="institutionNameCertificate"
                          name="institutionNameCertificate" placeholder="Enter name as it appears on certificate"
                          formControlName="schoolnameincertificate" />
                      </div>
                      <div class="form-group">
                        <label for="latitude" class="form-label">Latitude Co-ordinate</label>
                        <input type="number" class="form-control kemis-input" id="latitude" name="latitude"
                          placeholder="Enter latitude" step="any" formControlName="latitude" />
                      </div>
                      <div class="form-group">
                        <label for="longitude" class="form-label">Longitude Co-ordinate</label>
                        <input type="number" class="form-control kemis-input" id="longitude" name="longitude"
                          placeholder="Enter longitude" step="any" formControlName="longitude" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- TVET and Higher Education Bank Information Section -->
                <div *ngIf="selectedType == 'higher' || selectedType == 'tvet'" id="bank-information-section"
                  class="institution-specific-section">
                  <div class="form-section bank-section">
                    <h4 class="section-title">
                      <i class="fas fa-university section-icon"></i>
                      Bank Information
                    </h4>
                    <div class="form-grid">
                      <div class="form-group">
                        <label for="simbaAcc" class="form-label">SIMBA ACC</label>
                        <input type="text" class="form-control kemis-input" id="simbaAcc" name="simbaAcc"
                          placeholder="Enter SIMBA account number" />
                      </div>
                      <div class="form-group">
                        <label for="gpaAccNo" class="form-label">GPA ACC No</label>
                        <input type="text" class="form-control kemis-input" id="gpaAccNo" name="gpaAccNo"
                          placeholder="Enter GPA account number" />
                      </div>
                      <div class="form-group">
                        <label for="bankBranch" class="form-label">Bank Branch</label>
                        <input type="text" class="form-control kemis-input" id="bankBranch" name="bankBranch"
                          placeholder="Enter bank branch" />
                      </div>
                      <div class="form-group">
                        <label for="bankName" class="form-label">Bank Name</label>
                        <input type="text" class="form-control kemis-input" id="bankName" name="bankName"
                          placeholder="Enter bank name" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-actions">
                  <button type="button" class="btn kemis-btn-secondary" id="back-to-step-1"
                    (click)="submitted=false;previousStep()">
                    <i class="fas fa-chevron-left"></i>
                    Back
                  </button>
                  <div class="d-flex gap-2 justify-content-end" *ngIf="registrationType == 'new'">
                    <!-- [disabled]="instituteRegForm.invalid" -->
                    <button type="button" class="btn kemis-btn-primary" id="continue-to-preview"
                      data-bs-target="#myModal" data-bs-toggle="modal" (click)="isSave=false;openPreviewModal()">
                      Preview
                    </button>
                    <button type="button" class="btn kemis-btn-primary" id="continue-to-payment"
                      [disabled]="isSave && isDataProtectionChecked == false" (click)="onSubmit(instituteRegForm)">
                      Save and Continue
                      <i class="fas fa-chevron-right"></i>
                      <!--  [disabled]="instituteRegForm.invalid" -->
                    </button>
                  </div>
                  <div class="d-flex gap-2 justify-content-end" *ngIf="registrationType == 're'">
                    <button type="button" class="btn kemis-btn-primary" id="continue-to-preview" [disabled]="isSave"
                      data-bs-target="#myModal" data-bs-toggle="modal" (click)="isSave=false;openPreviewModal()">
                      Preview
                    </button>
                    <button type="button" class="btn kemis-btn-primary" id="continue-to-payment"
                      (click)="onSubmit(instituteRegForm)">
                      Save and Continue
                      <i class="fas fa-chevron-right"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Success Message -->
      <div class="step-content" *ngIf="currentStep === 3" id="success-content">
        <div class="row justify-content-center">
          <div class="col-lg-6">
            <div class="kemis-card text-center">
              <div class="card-body">
                <div class="success-icon">
                  <i class="fas fa-check-circle"></i>
                </div>
                <h2 class="success-title">Registration Successful!</h2>
                <p class="success-message">
                  Your institution has been successfully registered with KEMIS.
                  You will receive a confirmation email shortly.
                </p>
                <button class="btn kemis-btn-primary" onclick="location.reload()">
                  Register Another Institution
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>

  <!-- Footer -->
  <footer class="kemis-footer">
    <div class="container">
      <div class="text-center">
        <p class="mb-1">
          &copy; {{ currentYear }} Ministry of Education, Republic of Kenya. All
          rights reserved.
        </p>
        <p class="mb-0">
          For technical support, contact:
          <a href="mailto:support&#64;education.go.ke">support&#64;education.go.ke</a>
        </p>
      </div>
    </div>
  </footer>
</body>

<div *ngIf="selectedType == 'basic'">
  <div class="modal" tabindex="-1" id="myModal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Institution Onboarding Details</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">
                Institution Details
              </legend>
              <div class="row mb-2" *ngIf="registrationType === 're'">
                <div class="col-md-6">
                  <strong>Registration Number</strong>
                  :
                  {{ userDetails?.registration_number }}
                </div>
                <div class="col-md-6">
                  <strong>Reason For Reregistration</strong>:
                  {{
                  userDetails?.reregistration_reasons == 1
                  ? "Need to increase school enrolment capacity"
                  : userDetails?.reregistration_reasons == 2
                  ? "Need to change school name"
                  : userDetails?.reregistration_reasons == 3
                  ? "Expiry of licenses e.t.c"
                  : ""
                  }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Institute Type</strong> :{{
                  userDetails?.institution_type == 1
                  ? "Boy's School"
                  : userDetails?.institution_type == 2
                  ? "Girl's School"
                  : "Mixed School"
                  }}
                </div>
                <div class="col-md-6">
                  <strong>{{
                    registrationType === "re" ? "Email Address" : "Email"
                    }}</strong>:{{ userDetails?.email }}
                </div>
                <!-- </div>
               <div class="row mb-2"> -->
                <div class="col-md-6">
                  <strong>{{
                    registrationType === "re"
                    ? "Telephone Number"
                    : "Mobile Number"
                    }}</strong>
                  :
                  {{userDetails?.mobilenocode_countryName}} {{ userDetails?.mobileno }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Name</strong> :
                  {{ userDetails?.TNT_NAME }}
                </div>
                <div class="col-md-6">
                  <strong>Head of Institution</strong> :
                  {{ userDetails?.tnt_admin_name }}
                </div>
                <!-- </div>
               <div class="row mb-2"> -->
                <div class="col-md-6">
                  <strong>Postal Code</strong> :
                  {{ userDetails?.TNT_DESCRIPTION }}
                </div>
                <!--  <div class="col-md-6" *ngIf="registrationType === 'new'">
                  <strong>Nearest landmark/town</strong> :
                  {{ userDetails?.landmark }}
                </div>-->
                <!-- </div>
               <div class="row mb-2"> -->
                <div class="col-md-6">
                  <strong>County</strong> :
                  {{ userDetails?.COUNTIES_NAME }}
                </div>
                <div class="col-md-6">
                  <strong>Sub County</strong> :
                  {{ userDetails?.SUB_COUNTIES_NAME }}
                </div>
                <!-- </div>
               <div class="row mb-2"> -->
                <div class="col-md-6" *ngIf="registrationType === 'new'">
                  <strong>Constituency</strong> :
                  {{ getConstituencyList(userDetails?.constituency) }}
                </div>
                <div class="col-md-6">
                  <strong>Institution Level</strong> :
                  {{ getLevelDescription(userDetails?.schoollevel) }}
                </div>
                <div class="col-md-6">
                  <strong> Have a Valid Registration Certificate?</strong> :
                  {{ userDetails?.is_valid_certificate ==true ? 'YES':'NO'}}
                </div>
                <div class="col-md-6" *ngIf="userDetails?.is_valid_certificate ==true">
                  <strong> Institution Certificate Number</strong> :
                  {{ userDetails?.registration_no}}
                </div>
                <div class="col-md-6 mb-2" *ngIf="userDetails?.is_valid_certificate == true">
                  <strong>Institution Certificate</strong> :
                  <a *ngIf="userDetails?.tnt_registration_certificate"
                    [href]="userDetails?.tnt_registration_certificate" target="_blank" class="text-primary fw-semibold">
                    View Document
                  </a>
                  <span *ngIf="!userDetails?.tnt_registration_certificate" class="text-muted">
                    No document
                  </span>
                </div>
                <div class="col-md-6" *ngIf="['1','3'].includes(userDetails?.institution_type)">
                  <strong> Number of Boys Learners</strong> :
                  {{ userDetails?.tnt_boys_capacity}}
                </div>
                <div class="col-md-6" *ngIf="['1','3'].includes(userDetails?.institution_type)">
                  <strong> Number of SNE Boys</strong> :
                  {{ userDetails?.tnt_sne_boyscapacity}}
                </div>
                <div class="col-md-6" *ngIf="['2','3'].includes(userDetails?.institution_type)">
                  <strong> Number of Girls Learners </strong> :
                  {{ userDetails?.tnt_girls_capacity }}
                </div>
                <div class="col-md-6" *ngIf="['2','3'].includes(userDetails?.institution_type)">
                  <strong> Number of SNE Girls </strong> :
                  {{ userDetails?.tnt_sne_girlscapacity }}
                </div>
                <div class="col-md-6">
                  <strong> Total Number of Learners </strong> :
                  {{ userDetails?.tnt_sne_capacity}}
                </div>
                <!-- </div>
               <div class="row mb-2" *ngIf="registrationType === 'new'"> -->
                <!-- <div class="col-md-6">
                  <strong>Institution Reg No</strong> :
                  {{ userDetails?.school_regno }}
                </div> -->
                <div class="col-md-6">
                  <strong>Institution Postal Location</strong> :
                  {{ userDetails?.schoollocation }}
                </div>
                <!-- </div>

               <div class="row" mb-2> -->
                <div class="col-md-6" *ngIf="registrationType == 're'">
                  <strong>Institution Name in Certificate</strong> :
                  {{ userDetails?.schoolnameincertificate }}
                </div>
                <!-- </div>
               <div class="row mb-2"> -->
                <div class="col-md-6">
                  <strong>Latitude Co-ordinate</strong> :
                  {{ userDetails?.latitude }}
                </div>
                <div class="col-md-6">
                  <strong>Longitude Co-ordinate</strong> :
                  {{ userDetails?.longitude }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Bank Information</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>SIMBA ACC</strong> :
                  {{ userDetails?.simba_acc }}
                </div>
                <div class="col-md-6">
                  <strong>GPA ACC No</strong> :
                  {{ userDetails?.gpa_accno }}
                </div>
              </div>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Bank Name</strong> :
                  {{ userDetails?.bankname }}
                </div>
                <div class="col-md-6">
                  <strong>Bank Branch</strong> :
                  {{ userDetails?.bankbranch }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Teaching Staff</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Teaching Male</strong> :
                  {{ userDetails?.noofteaching_male }}
                </div>
                <div class="col-md-6">
                  <strong>Teaching Female</strong> :
                  {{ userDetails?.noofteaching_female }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.noofteaching_total }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Non-Teaching Staff</legend>
              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Non-Teaching male</strong> :
                  {{ userDetails?.noofnonteaching_male }}
                </div>
                <div class="col-md-6">
                  <strong>Non-Teaching Female</strong> :
                  {{ userDetails?.noofnonteaching_female }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.noofnonteaching_total }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="container pt-2 d-none" *ngIf="registrationType === 'new'">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Learner Enrolment</legend>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Enrollment Boys</strong> :
                  {{ userDetails?.enrollment_boys }}
                </div>
                <div class="col-md-6">
                  <strong>Enrollment Girls</strong> :
                  {{ userDetails?.enrollment_girls }}
                </div>
                <div class="col-md-6">
                  <strong>Total</strong> :
                  {{ userDetails?.learnerenrolment_total }}
                </div>
              </div>
            </fieldset>
          </div>
          <div class="container pt-2" *ngIf="registrationType === 'new'">
            <fieldset class="border rounded-3 p-3">
              <legend class="float-none w-auto px-3">Other Details</legend>

              <div class="row mb-2">
                <div class="col-md-6">
                  <strong>School Categories</strong> :
                  {{
                  userDetails?.sne_disability_status == 1
                  ? "Regular"
                  : userDetails?.sne_disability_status == 2
                  ? "Integrated"
                  : userDetails?.sne_disability_status == 3
                  ? "SNE"
                  : userDetails?.sne_disability_status == 4
                  ? "Regular with special unit"
                  : ""
                  }}
                </div>
                <div class="col-md-6" *ngIf="userDetails?.sne_disability_status != 1">
                  <strong>{{
                    userDetails?.sne_disability_status == 2
                    ? "Integrated"
                    : userDetails?.sne_disability_status == 3
                    ? "SNE"
                    : userDetails?.sne_disability_status == 4
                    ? "Regular with special unit"
                    : ""
                    }}</strong>
                  {{ userDetails?.sne_disability_type_names }}
                </div>
                <div class="col-md-6" *ngIf="shouldShowSneBlock()">
                  <strong>Sub Categories</strong>
                  :
                  {{ userDetails?.sne_subCategories_names }}
                </div>
                <div class="col-md-6">
                  <strong>Accommodation Type</strong> :
                  {{
                  userDetails?.accommodation_type == 1
                  ? "Day"
                  : userDetails?.accommodation_type == 2
                  ? "Boarding"
                  : userDetails?.accommodation_type == 3
                  ? "Hybrid"
                  : ""
                  }}
                </div>
              </div>
              <!-- <div class="row mb-2">
                <div class="col-md-6">
                  <strong>Email</strong> :
                  {{ userDetails?.email }}
                </div>
                <div class="col-md-6">
                  <strong>Mobile Number</strong> :
                  {{ userDetails?.mobileno }}
                </div>
              </div> -->
              <div class="row mb-2">

                <div class="col-md-6">
                  <strong>Application Type</strong> :
                  {{ getApplicationTypeName(userDetails?.applicationtype) }}
                </div>
              </div>
            </fieldset>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedType == 'higher' || selectedType == 'tvet'">
    <div class="modal" tabindex="-1" id="myModal">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Institution Registration Details</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="container">
              <fieldset class="border rounded-3 p-3">
                <legend class="float-none w-auto px-3">
                  Institution Details
                </legend>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <strong>Institution Name</strong> :
                    {{ userDetails?.TNT_NAME }}
                  </div>
                  <div class="col-md-6">
                    <strong>Head of Institution</strong> :
                    {{ userDetails?.tnt_admin_name }}
                  </div>
                  <div class="col-md-6">
                    <strong>Address</strong> :
                    {{ userDetails?.TNT_DESCRIPTION }}
                  </div>
                </div>
                <div class="row mb-2">
                  <!-- <div class="col-md-6">
                  <strong>Nearest landmark/town</strong> :
                  {{ userDetails?.landmark }}
                </div> -->
                  <div class="col-md-6">
                    <strong>County</strong> :
                    {{ userDetails?.COUNTIES_NAME }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <strong>Sub County</strong> :
                    {{ userDetails?.SUB_COUNTIES_NAME }}
                  </div>
                  <div class="col-md-6">
                    <strong>Constituency</strong> :
                    {{ getConstituencyList(userDetails?.constituency) }}
                  </div>
                </div>
                <div class="row mb-2">
                  <!-- <div class="col-md-6">
                  <strong>Institution Reg No</strong> :
                  {{ userDetails?.school_regno }}
                </div> -->
                  <div class="col-md-6">
                    <strong>Institution Location</strong> :
                    {{ userDetails?.schoollocation }}
                  </div>
                  <!-- </div>
              <div class="row mb-2"> -->
                  <div class="col-md-6">
                    <strong>Institution Level</strong> :
                    {{ getLevelDescription(userDetails?.schoollevel) }}
                  </div>
                  <div class="col-md-6">
                    <strong>Institution Name in Certificate</strong> :
                    {{ userDetails?.schoolnameincertificate }}
                  </div>
                  <!-- </div>
              <div class="row mb-2"> -->
                  <div class="col-md-6">
                    <strong>Latitude Co-ordinate</strong> :
                    {{ userDetails?.latitude }}
                  </div>
                  <div class="col-md-6">
                    <strong>Longitude Co-ordinate</strong> :
                    {{ userDetails?.longitude }}
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="container pt-2">
              <fieldset class="border rounded-3 p-3">
                <legend class="float-none w-auto px-3">Bank Information</legend>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <strong>SIMBA ACC</strong> :
                    {{ userDetails?.simba_acc }}
                  </div>
                  <div class="col-md-6">
                    <strong>GPA ACC No</strong> :
                    {{ userDetails?.gpa_accno }}
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-md-6">
                    <strong>Bank Name</strong> :
                    {{ userDetails?.bankname }}
                  </div>
                  <div class="col-md-6">
                    <strong>Bank Branch</strong> :
                    {{ userDetails?.bankbranch }}
                  </div>
                </div>
              </fieldset>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-bs-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>